import React from "react";
import { Button, FormGroup, Input, Label } from "../components/Modal";
import { CreateGuide, CreateGuideRequest } from "./GuideStore";
import { useNavigate } from "react-router-dom";
import OrganizationContextSwitcher from "../organizations/ContextSwitcher";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const GuidesCreate = () => {
    const [name, setName] = React.useState("");
    const [organizationID, setOrganizationID] = React.useState("");
    const [key, setKey] = React.useState("");
    const [guideURI, setGuideURI] = React.useState("");
    const [thumbnailURI, setThumbnailURI] = React.useState("");

    const navigate = useNavigate();

    const create = async () => {
        var res = await CreateGuide({ name, organizationID, key, guideURI, thumbnailURI } as CreateGuideRequest);
        navigate("/guides");
    };

    return (
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <OrganizationContextSwitcher></OrganizationContextSwitcher>
            
            {/* Header Section */}
            <div className="flex items-center gap-3 pb-6 border-b border-gray-200 mb-6">
                <FontAwesomeIcon icon={["fad", "book-open"]} className="text-3xl text-purple-500" />
                <div>
                    <h2 className="text-3xl font-bold text-gray-900">Create Guide</h2>
                    <p className="text-sm text-gray-600 mt-1">Add a new user guide to your organization</p>
                </div>
            </div>

            {/* Form Section */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <div className="space-y-6">
                    <FormGroup>
                        <Label htmlFor="name">Name</Label>
                        <Input 
                            id="name"
                            type="text"
                            value={name} 
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter guide name"
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label htmlFor="organization">Organization</Label>
                        <Input 
                            id="organization"
                            type="text"
                            value={organizationID} 
                            onChange={(e) => setOrganizationID(e.target.value)}
                            placeholder="Enter organization ID"
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label htmlFor="key">Key</Label>
                        <Input 
                            id="key"
                            type="text"
                            value={key} 
                            onChange={(e) => setKey(e.target.value)}
                            placeholder="Enter unique key"
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label htmlFor="guideURI">Guide URI</Label>
                        <Input 
                            id="guideURI"
                            type="text"
                            value={guideURI} 
                            onChange={(e) => setGuideURI(e.target.value)}
                            placeholder="https://example.com/guide"
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label htmlFor="thumbnailURI">Thumbnail URI</Label>
                        <Input 
                            id="thumbnailURI"
                            type="text"
                            value={thumbnailURI} 
                            onChange={(e) => setThumbnailURI(e.target.value)}
                            placeholder="https://example.com/thumbnail.jpg"
                        />
                        {thumbnailURI && (
                            <div className="mt-3">
                                <p className="text-sm text-gray-600 mb-2">Preview:</p>
                                <img 
                                    src={thumbnailURI} 
                                    alt="Thumbnail preview" 
                                    className="w-48 h-32 object-cover rounded-md border border-gray-200"
                                />
                            </div>
                        )}
                    </FormGroup>

                    <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
                        <Button variant="outline-secondary" onClick={() => navigate("/guides")}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={create}>
                            <FontAwesomeIcon icon={["fad", "save"]} className="mr-2" />
                            Create Guide
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GuidesCreate;
